import { toString30pk9tzaqopn as toString } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var AuthHookDataClass;
function AuthHookData() {
  if (AuthHookDataClass === VOID) {
    class $ {
      constructor(user, authenticated, loading, error, loginWithRedirect, getIdTokenClaims, logout, getAccessTokenSilently) {
        this.u3q_1 = user;
        this.v3q_1 = authenticated;
        this.w3q_1 = loading;
        this.x3q_1 = error;
        this.y3q_1 = loginWithRedirect;
        this.z3q_1 = getIdTokenClaims;
        this.a3r_1 = logout;
        this.b3r_1 = getAccessTokenSilently;
      }
      xe() {
        return this.v3q_1;
      }
      c3r() {
        return this.w3q_1;
      }
      toString() {
        return 'AuthHookData(user=' + toString(this.u3q_1) + ', authenticated=' + this.v3q_1 + ', loading=' + this.w3q_1 + ', error=' + toString(this.x3q_1) + ', loginWithRedirect=' + toString_0(this.y3q_1) + ', getIdTokenClaims=' + toString_0(this.z3q_1) + ', logout=' + toString_0(this.a3r_1) + ', getAccessTokenSilently=' + toString_0(this.b3r_1) + ')';
      }
      hashCode() {
        var result = this.u3q_1 == null ? 0 : hashCode(this.u3q_1);
        result = imul(result, 31) + getBooleanHashCode(this.v3q_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.w3q_1) | 0;
        result = imul(result, 31) + (this.x3q_1 == null ? 0 : hashCode(this.x3q_1)) | 0;
        result = imul(result, 31) + hashCode(this.y3q_1) | 0;
        result = imul(result, 31) + hashCode(this.z3q_1) | 0;
        result = imul(result, 31) + hashCode(this.a3r_1) | 0;
        result = imul(result, 31) + hashCode(this.b3r_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AuthHookData()))
          return false;
        if (!equals(this.u3q_1, other.u3q_1))
          return false;
        if (!(this.v3q_1 === other.v3q_1))
          return false;
        if (!(this.w3q_1 === other.w3q_1))
          return false;
        if (!equals(this.x3q_1, other.x3q_1))
          return false;
        if (!equals(this.y3q_1, other.y3q_1))
          return false;
        if (!equals(this.z3q_1, other.z3q_1))
          return false;
        if (!equals(this.a3r_1, other.a3r_1))
          return false;
        if (!equals(this.b3r_1, other.b3r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'AuthHookData');
    AuthHookDataClass = $;
  }
  return AuthHookDataClass;
}
//region block: exports
export {
  AuthHookData as AuthHookData2x0lxghdz8ao,
};
//endregion

//# sourceMappingURL=AuthHookData.mjs.map
